import type { ChipProps as MuiChipProps } from "@mui/material"
import dayjs from "dayjs"
import type { ReactElement } from "react"
import React from "react"

import StyledChip from "@/components/common/Chip/Chip"

const DateChip = ({ date, ...rest }: { date?: string | null } & MuiChipProps): ReactElement => {
  return <StyledChip {...rest} label={<span>{date ? dayjs(date).format("MM/DD/YYYY") : "--/--/----"}</span>} />
}

export default DateChip
